import { defineMessages } from 'react-intl';

export const skillFileUploadStatusMessages = defineMessages({
  uploading: {
    defaultMessage: 'Uploading',
    id: '0z6qGfS+wD',
    description: 'Status while a skill file is being uploaded',
  },
  uploadingWithProgress: {
    defaultMessage: 'Uploading {progress, number}%',
    id: 'rcqgHG+Pl2',
    description: 'Status while a skill file upload has measurable progress',
  },
  processing: {
    defaultMessage: 'Processing',
    id: 'PNoWvGYXS7',
    description: 'Status while an uploaded skill file is being processed',
  },
  chipPhase: {
    defaultMessage:
      '<filenameStyle>{filename}</filenameStyle><phaseStyle>{phase, select, uploading {· Uploading} processing {· Processing} other {}}</phaseStyle>',
    id: 'vVB0bXer2i',
    description: 'Skill file upload chip with filename and current phase',
  },
  cardPhase: {
    defaultMessage:
      '{phase, select, uploading {Skill file · Uploading} processing {Skill file · Processing} other {Skill file}}',
    id: 'jlmTIN3WnE',
    description: 'Skill file upload card subtitle with current phase',
  },
  uploadProgressAria: {
    defaultMessage: 'Upload progress for {filename}',
    id: '/IFnKM1la3',
    description: 'Accessible label on byte upload progress for a skill file',
  },
  processingProgressAria: {
    defaultMessage: 'Processing {filename}',
    id: 'R+Ej3pw3c7',
    description: 'Accessible label on indeterminate processing progress for a skill file',
  },
});
